import { LanguageJsonldLanguageRead, PrintingOrderJsonldPrintingOrderRead } from '@/api/generated';
import AddressInput from '@/atoms/forms/Input/Address';
import TextInput from '@/atoms/forms/Input/Text/Input';
import Select from '@/atoms/forms/Select';
import SecondaryTitle from '@/molecules/titles/SecondaryTitle';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useCreatePrintingModal from './hook';

const CreatePrintingOrderModal = ({
  closeModal,
  orderName,
  orderLang,
  id,
  onSubmit,
}: {
  closeModal: () => void;
  orderName?: string;
  orderLang?: LanguageJsonldLanguageRead;
  id?: string;
  onSubmit?: (data: PrintingOrderJsonldPrintingOrderRead) => void;
}) => {
  const { t } = useTranslation();
  const { handleSubmit, formMethods, languagesOptions } = useCreatePrintingModal({
    orderName,
    orderLang,
    id,
    onSubmit,
    closeModal,
  });

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isLoading={formMethods.formState.isSubmitting}
      isSubmitDisabled={formMethods.formState.isSubmitting}
      onSubmit={handleSubmit}
      submitLabel={id ? t('modify-order') : t('create-order')}
      title={id ? 'modify-order' : 'new-print-order'}
    >
      <div className="flex flex-col pb-4">
        <FormProvider {...formMethods}>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <fieldset className="flex flex-col gap-4">
              <SecondaryTitle showLine>{t('printing-options')}</SecondaryTitle>
              <TextInput label="order-name" name="name" />
              <Select label="printing-language" name="language" options={languagesOptions} placeholder="language" />
            </fieldset>
            <fieldset className="flex flex-col gap-4">
              <SecondaryTitle showLine>{t('printing-delivery-address')}</SecondaryTitle>
              <AddressInput
                modalTitle={t('my-address')}
                name="shippingValidatedAddress"
                placeHolderLabel={t('inputAddress.placeholder')}
              />
              <SecondaryTitle showLine>{t('printing-billing-address')}</SecondaryTitle>
              <AddressInput
                modalTitle={t('my-address')}
                name="billingValidatedAddress"
                placeHolderLabel={t('inputAddress.placeholder')}
              />
            </fieldset>
          </form>
        </FormProvider>
      </div>
    </ModalClassicLayout>
  );
};

export default CreatePrintingOrderModal;
